import {
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Box,
    SelectChangeEvent,
} from "@mui/material";
import { Dispatch, SetStateAction } from "react";
type TypeOption = {
    label: string;
    value: string;
};
const compensateTypes: TypeOption[] = [
    {
        label: "الكل",
        value: "compensate_type:traffic|days",
    },
    {
        label: "بيانات",
        value: "compensate_type:traffic",
    },
    {
        label: "فترة",
        value: "compensate_type:days",
    },
];

type Props = {
    filterValues: {
        compensate_type: string;
        gift_type_id: string;
    };
    setFilterValues: Dispatch<SetStateAction<{ compensate_type: string, gift_type_id: string }>>;
};

const CompensateTypeFilterBox = ({ filterValues, setFilterValues }: Props) => {
    const handleChange: any = (e: SelectChangeEvent<string>) => {
        setFilterValues({
            ...filterValues,
            compensate_type: e.target.value,
        });
    };
    return (
        <Box
            sx={{
                flex: "1",
                minWidth: "230px",
            }}
        >
            <FormControl fullWidth>
                <InputLabel>نوع القيمة</InputLabel>
                <Select
                    name="compensate_type_filter"
                    value={filterValues.compensate_type}
                    label="نوع القيمة"
                    onChange={handleChange}
                >

                    {compensateTypes.map((option: TypeOption) => {
                        return (
                            <MenuItem value={option.value} key={option.value}>
                                {option.label}
                            </MenuItem>
                        );
                    })}
                </Select>
            </FormControl>
        </Box>
    );
};

export default CompensateTypeFilterBox;
